import { render } from "./Table.vue?vue&type=template&id=6743effa&scoped=true&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=6743effa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6743effa"]])

export default __exports__